import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee69c82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sound-output-page-contents" }
const _hoisted_2 = { class: "evollu-title-description" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "subtitle-text" }
const _hoisted_5 = { class: "body-content" }
const _hoisted_6 = { class: "output-buttons-row mb-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center-div" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "i-speacker mt-4" })
], -1))
const _hoisted_8 = { class: "mt-3 output-div-label" }
const _hoisted_9 = { class: "output-button-label" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center-div" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "i-headphones mt-4" })
], -1))
const _hoisted_11 = { class: "mt-3 output-div-label" }
const _hoisted_12 = { class: "output-button-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.soundOutputPage.title), 1)
      ]),
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('select_output')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: _normalizeClass(["output-button output-btn-left primary-bg-color", {'custom-button-disabled': !_ctx.canGoNextPage}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick(_ctx.computer)))
        }, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('speakers')), 1)
          ])
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["output-button primary-bg-color", {'custom-button-disabled': !_ctx.canGoNextPage}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick(_ctx.headphones)))
        }, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('headphones')), 1)
          ])
        ], 2)
      ])
    ])
  ]))
}